/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
   
    var type1Arr = [
      {value: "", label: "N-white T-Body"},

    ];
    var type2Arr = [
      {value: "", label: "C-Camel T-Body"},

    ];
    var type3Arr = [
      {value: "", label: "R-Black T-Body"},

    ];
    var otherArr = [
      {value: "", label: "▼"}
    ];
    function setOption(radio) {
      var target;
      var pullObj;
      var i;
      if ((radio.value) == 'type1') {
        target = type1Arr;
      } else if ((radio.value) == 'type2') {
        target = type2Arr;
    } else if ((radio.value) == 'type3') {
        target = type3Arr;
      } else {
        target = otherArr;
      }
      pullObj = document.getElementById('category');
      while (pullObj.lastChild) {
        pullObj.removeChild(pullObj.lastChild);
      }
      for (i = 0; i < target.length; i++) {
        let option = document.createElement('option');
        option.value = target[i].value;
        option.text = target[i].label;
        pullObj.appendChild(option);
      }
    }
 